export default {"src":"/_next/static/media/Vipps.47f854ee.svg","height":66,"width":164,"blurWidth":0,"blurHeight":0};